import React, { useState, useEffect } from 'react';
import './Menu.css';
import { useCartStore } from '../context/cartStore';
import { toast } from 'react-toastify';
import { menuAPI } from '../services/api';
import ugaliPlain from '../assets/ugali_plain.jfif';
import samakiWetFry from '../assets/samaki_wet_fry.webp';
import mbuziChoma from '../assets/mbuzi_choma.jfif';
import mbuziWetFry from '../assets/mbuzi_wet_fry.jfif';
import dryFryImage from '../assets/Air-Fryer-chicken-legs-with-dry-rub-10.jpg';
import dielDryFryImage from '../assets/diel dry fry.jpg';
import beefDryFryImage from '../assets/abula.jfif';
import kukuFull from '../assets/kuku_full.jfif';
import tumboPlain from '../assets/tumbo_plain.jfif';
import chickenStew from '../assets/chicken_stew.jfif';
import chipsPlain from '../assets/chips_plain.jfif';
import delmonteMango from '../assets/delmonte_mango.jpg';
import minutemaid from '../assets/minutemaid.jfif';
import mmImage from '../assets/mm.jpg';
import sodaImage from '../assets/soda.jpg';
import afiaImage from '../assets/afia.png';
import monsterImage from '../assets/monster.jfif';
import redbullImage from '../assets/redbull.jfif';
import bestCreamImage from '../assets/best_cream.webp';
import baileysCreamImage from '../assets/baileys_cream.jpg';
import gordonsGinImage from '../assets/gordons_gin.jpg';
import chivasRegalImage from '../assets/chivas_regal_12yrs.jpg';
import williamLawsonsImage from '../assets/william_lawsons.jpg';
import predatorImage from '../assets/predator.jfif';
import powerPlayImage from '../assets/power_play.jpeg';
import dasaniWaterImage from '../assets/dasani_water.webp';
import dasaniImage from '../assets/dasani.webp';
import keringetImage from '../assets/keringet.jfif';
import keringet1LImage from '../assets/keringet_l.jpg';
import robertsonRedImage from '../assets/robertson_red.webp';
import robertsonImage from '../assets/robertsonwhite.jpg';
import frImage from '../assets/fr.jpg';
import fwImage from '../assets/fw.jpg';
import fourRedImage from '../assets/4r.jfif';
import fourWhiteImage from '../assets/4w.webp';
import cellarRedImage from '../assets/cellar_cask_red.png';
import cellarWhiteImage from '../assets/celar_white.jfif';
import capriceRedImage from '../assets/cpr.jfif';
import capriceWhiteImage from '../assets/cpw.png';
import drostdyImage from '../assets/dro.webp';
import tuskerLiteImage from '../assets/tl.jfif';
import tuskerLagerImage from '../assets/tlaga.jfif';
import whitecapImage from '../assets/wcap.jfif';
import tuskerCiderImage from '../assets/tcider.webp';
import guinessImage from '../assets/gs.jfif';
import baloziImage from '../assets/balozi.jfif';
import guaranaImage from '../assets/guarana.jfif';
import snapImage from '../assets/snap.jfif';
import jwBlackImage from '../assets/jw_black.jpg';
import grantsImage from '../assets/grants.jpg';
import jackDanielsImage from '../assets/jack_daniels.jpg';
import martellVsImage from '../assets/martell_vs.jpg';
import ballantinesImage from '../assets/ballantines.jpg';
import hennessyImage from '../assets/hennessy.jfif';
import amarulaImage from '../assets/amarula.jpg';
import glenfiddichImage from '../assets/glenfiddich.jpg';
import viceroyImage from '../assets/viceroy.jpg';
import blackAndWhiteImage from '../assets/black_and_white.jpg';
import richotImage from '../assets/richot.jpg';
import huntersChoiceImage from '../assets/hunters_choice.webp';
import captainMorganImage from '../assets/captain_morgan.jpg';


const Menu = () => {
  const publicUrl = process.env.PUBLIC_URL || '';
  const [selectedVariants, setSelectedVariants] = useState({});
  const [menuItems] = useState([
    { _id: 1, category: 'Food', name: 'Fish Boil', description: 'Fresh fish boiled to perfection', price: 300, image: `${publicUrl}/images/fish-boil.jfif` },
    { _id: 2, category: 'Food', name: 'Fish Dry Fry', description: 'Crispy dry fried fish', price: 300, image: `${publicUrl}/images/fish-dry-fry.jfif` },
    { _id: 3, category: 'Food', name: 'Fish Wet Fry', description: 'Juicy wet fried fish', price: 300, image: samakiWetFry },
    { _id: 4, category: 'Food', name: 'Fish Plain', description: 'Extra large fish', price: 350, image: `${publicUrl}/images/fish-plain.jfif` },
    { _id: 5, category: 'Food', name: 'Mbuzi choma 1/4', description: 'Choma roasted to perfection', price: 350, image: mbuziChoma },
    { _id: 6, category: 'Food', name: 'Mbuzi Dry Fry 1/4', description: 'Crispy fried to perfection', price: 350, image: dielDryFryImage },
    { _id: 7, category: 'Food', name: 'Mbuzi Wet Fry', description: 'Crispy wet fried mbuzi', price: 300, image: mbuziWetFry },
    { _id: 8, category: 'Food', name: 'Chicken Wet Fry 1/4', description: 'Grilled chicken dish', price: 350, image: `${publicUrl}/images/chicken-wet-fry.jfif` },
    { _id: 9, category: 'Food', name: 'Chicken Dry Fry', description: 'African Special Fried dish', price: 400, image: dryFryImage },
    { _id: 10, category: 'Food', name: 'Chicken Full', description: 'Grilled chicken dish', price: 1600, image: kukuFull },
    { _id: 11, category: 'Food', name: 'Beef Stew', description: 'Rich beef stew with vegetables', price: 300, image: `${publicUrl}/images/beef-stew.jpg` },
    { _id: 12, category: 'Food', name: 'Beef Special Fry 1/4', description: 'Rich beef Dry Fried', price: 300, image: beefDryFryImage },
    { _id: 13, category: 'Food', name: 'Ugali plain', description: 'Traditional maize meal', price: 50, image: ugaliPlain },
    { _id: 14, category: 'Food', name: 'Chapati', description: 'Fluffy flatbread', price: 50, image: `${publicUrl}/images/chapo.jfif` },
    { _id: 15, category: 'Food', name: 'Chips', description: 'Plain fried chips', price: 150, image: chipsPlain },
    { _id: 16, category: 'Food', name: 'Matumbo', description: 'Spiced Fresh Matumbo', price: 200, image: tumboPlain },
    { _id: 17, category: 'Soft Drinks', name: 'Delmonte', description: 'Cold seasonal fresh juice', price: 400, image: delmonteMango, variantOptions: ['Mango', 'Orange', 'Tropical', 'Passion', 'Apple'] },
    { _id: 18, category: 'Soft Drinks', name: 'Minute Made 500ml', description: 'Chilled Local Minute Made', price: 100, image: minutemaid, variantOptions: ['Mango', 'Orange', 'Tropical', 'Passion', 'Apple'] },
    { _id: 19, category: 'Soft Drinks', name: 'Minute Made 1L', description: 'Cold', price: 250, image: mmImage, variantOptions: ['Mango', 'Orange', 'Tropical', 'Passion', 'Apple'] },
    { _id: 20, category: 'Soft Drinks', name: 'Soda 500ml', description: 'Cold soda', price: 100, image: sodaImage, variantOptions: ['Krest', 'Orange', 'Cocacola', 'Blackcurrent', 'Stony', 'Sprite'] },
    { _id: 21, category: 'Soft Drinks', name: 'Afia', description: 'Fresh Juice', price: 100, image: afiaImage },
    { _id: 22, category: 'Soft Drinks', name: 'Monster', description: 'Energy drink', price: 300, image: monsterImage },
    { _id: 23, category: 'Soft Drinks', name: 'RedBull', description: 'Energy drink', price: 300, image: redbullImage },
    { _id: 69, category: 'Soft Drinks', name: 'Predator', description: 'Energy drink', price: 100, image: predatorImage },
    { _id: 70, category: 'Soft Drinks', name: 'Power Play', description: 'Energy drink', price: 100, image: powerPlayImage },
    { _id: 24, category: 'Soft Drinks', name: 'Dasani 500Ml', description: 'Pure Bottled water', price: 50, image: dasaniWaterImage },
    { _id: 25, category: 'Soft Drinks', name: 'Dasani 1L', description: 'Pure bottled water', price: 100, image: dasaniImage },
    { _id: 26, category: 'Soft Drinks', name: 'Keringet 500Ml', description: 'Chilled mineral water', price: 100, image: keringetImage },
    { _id: 27, category: 'Soft Drinks', name: 'Keringet 1L', description: 'Pure bottled water', price: 150, image: keringet1LImage },
    { _id: 28, category: 'Wines and Beers', name: 'Robertson 750Ml', description: 'Smooth red wine', price: 1800, image: robertsonRedImage },
    { _id: 29, category: 'Wines and Beers', name: 'Robertson White 750Ml', description: 'Smooth white wine', price: 1800, image: robertsonImage },
    { _id: 30, category: 'Wines and Beers', name: 'Four Cousins', description: 'Red', price: 1300, image: frImage },
    { _id: 30, category: 'Wines and Beers', name: 'Four Cousins', description: 'White', price: 1300, image: fwImage },
    { _id: 31, category: 'Wines and Beers', name: 'Fourth Street', description: 'Red', price: 1300, image: fourRedImage },
    { _id: 32, category: 'Wines and Beers', name: 'Fourth Street', description: 'White', price: 1300, image: fourWhiteImage },
    { _id: 33, category: 'Wines and Beers', name: 'Cellar Cask', description: 'Red', price: 1400, image: cellarRedImage },
    { _id: 34, category: 'Wines and Beers', name: 'Cellar Cask', description: 'White', price: 1400, image: cellarWhiteImage },
    { _id: 35, category: 'Wines and Beers', name: 'Caprice', description: 'Red', price: 1300, image: capriceRedImage },
    { _id: 36, category: 'Wines and Beers', name: 'Caprice', description: 'White', price: 1300, image: capriceWhiteImage },
    { _id: 37, category: 'Wines and Beers', name: 'Drostdy Hof', description: 'Red Wine', price: 1400, image: drostdyImage },
    { _id: 38, category: 'Wines and Beers', name: 'Tusker Lite', description: 'Local craft beer Can', price: 300, image: tuskerLiteImage },
    { _id: 39, category: 'Wines and Beers', name: 'Tusker Lager', description: 'Local craft beer Can', price: 300, image: tuskerLagerImage },
    { _id: 40, category: 'Wines and Beers', name: 'WhiteCap', description: 'Local craft beer Can', price: 300, image: whitecapImage },
    { _id: 41, category: 'Wines and Beers', name: 'Tusker Cider', description: 'Local craft beer Can', price: 300, image: tuskerCiderImage },
    { _id: 42, category: 'Wines and Beers', name: 'Guiness', description: 'Local craft beer Can', price: 300, image: guinessImage },
    { _id: 43, category: 'Wines and Beers', name: 'Balozi', description: 'Local craft beer Can', price: 300, image: baloziImage },
    { _id: 44, category: 'Wines and Beers', name: 'Smirnof Guarana', description: 'Local craft beer Can', price: 300, image: guaranaImage },
    { _id: 45, category: 'Wines and Beers', name: 'Snap', description: 'Local craft beer Can', price: 300, image: snapImage },
    { _id: 46, category: 'Liquor', name: 'Johnny Walker Black 1L', description: 'Premium blended whisky', price: 5500, image: jwBlackImage },
    { _id: 47, category: 'Liquor', name: 'Johnny Walker Black 3/4', description: 'Premium blended whisky', price: 4800, image: jwBlackImage },
    { _id: 48, category: 'Liquor', name: 'Johnny Walker Red 1L', description: 'Smooth blended whisky', price: 3200, image: `${publicUrl}/images/red-label.jfif` },
    { _id: 49, category: 'Liquor', name: 'Johnny Walker Red 3/4', description: 'Smooth blended whisky', price: 2600, image: `${publicUrl}/images/red-label.jfif` },
    { _id: 50, category: 'Liquor', name: 'Grants 1L', description: 'Classic blended whisky', price: 3000, image: grantsImage },
    { _id: 51, category: 'Liquor', name: 'Grants 3/4', description: 'Classic blended whisky', price: 2500, image: grantsImage },
    { _id: 52, category: 'Liquor', name: 'Jack Daniels 3/4', description: 'Tennessee whiskey', price: 4000, image: jackDanielsImage },
    { _id: 53, category: 'Liquor', name: 'Martell VS 700ml', description: 'Fine cognac', price: 7000, image: martellVsImage },
    { _id: 54, category: 'Liquor', name: 'Martell VS 1L', description: 'Fine cognac', price: 7800, image: martellVsImage },
    { _id: 55, category: 'Liquor', name: 'Hennessy', description: 'Premium cognac', price: 6500, image: hennessyImage },
    { _id: 56, category: 'Liquor', name: 'Glenfiddich 12yrs 750ml', description: 'Single malt whisky', price: 8500, image: glenfiddichImage },
    { _id: 57, category: 'Liquor', name: 'Glenfiddich 15yrs 750ml', description: 'Single malt whisky', price: 12000, image: glenfiddichImage },
    { _id: 58, category: 'Liquor', name: 'Ballantines', description: 'Blended Scotch whisky', price: 3500, image: ballantinesImage },
    { _id: 59, category: 'Liquor', name: 'Best Cream 750ml', description: 'Cream liqueur', price: 1500, image: bestCreamImage },
    { _id: 60, category: 'Liquor', name: 'Bailey\'s Cream 750ml', description: 'Cream liqueur', price: 3000, image: baileysCreamImage },
    { _id: 61, category: 'Liquor', name: 'Gordon\'s Gin 1L', description: 'Dry gin', price: 3200, image: gordonsGinImage },
    { _id: 62, category: 'Liquor', name: 'Gordon\'s Gin 750ml', description: 'Dry gin', price: 2500, image: gordonsGinImage },
    { _id: 63, category: 'Liquor', name: 'Chivas Regal 12yrs', description: 'Premium blended Scotch', price: 5000, image: chivasRegalImage },
    { _id: 64, category: 'Liquor', name: 'William Lawsons 750ml', description: 'Blended whisky', price: 2500, image: williamLawsonsImage },
    { _id: 65, category: 'Liquor', name: 'Amarula 750ml', description: 'Cream liqueur', price: 3000, image: amarulaImage },
    { _id: 66, category: 'Liquor', name: 'Viceroy 3/4', description: 'Blended whisky', price: 1650, image: viceroyImage },
    { _id: 67, category: 'Liquor', name: 'Black and White 3/4', description: 'Blended whisky', price: 1500, image: blackAndWhiteImage },
    { _id: 68, category: 'Liquor', name: 'VAT 69 3/4', description: 'Blended whisky', price: 1900, image: `${publicUrl}/images/VAT-69.jfif` },
    { _id: 71, category: 'Liquor', name: 'VAT 69 1L', description: 'Blended whisky', price: 3000, image: `${publicUrl}/images/VAT-69.jfif` },
    { _id: 72, category: 'Liquor', name: 'Singleton 12 Years', description: 'Single malt whisky', price: 6500, image: `${publicUrl}/images/singleton-12-years.avif` },
    { _id: 73, category: 'Liquor', name: 'Richot 3/4', description: 'Blended whisky', price: 1600, image: richotImage },
    { _id: 74, category: 'Liquor', name: 'Hunters Choice 3/4', description: 'Blended whisky', price: 1300, image: huntersChoiceImage },
    { _id: 75, category: 'Liquor', name: 'Captain Morgan 3/4', description: 'Spiced rum', price: 1300, image: captainMorganImage },
  ]);

  const addToCart = useCartStore((state) => state.addToCart);

  const handleVariantChange = (itemId, variant) => {
    setSelectedVariants((prev) => ({ ...prev, [itemId]: variant }));
  };

  const handleAddToCart = (item) => {
    const selectedVariant = selectedVariants[item._id] || item.variantOptions?.[0] || '';
    const cartItem = selectedVariant
      ? { ...item, variant: selectedVariant, name: `${item.name} (${selectedVariant})` }
      : item;
    addToCart(cartItem);
    toast.success('Added to cart');
  };

  // Commented out API fetch for now
  // useEffect(() => {
  //   const fetchMenu = async () => {
  //     try {
  //       const response = await api.get('/menus');
  //       setMenuItems(response.data);
  //     } catch (error) {
  //       console.error('Error fetching menu:', error);
  //     }
  //   };
  //   fetchMenu();
  // }, []);

  const categories = ['Food', 'Soft Drinks', 'Wines and Beers', 'Liquor'];
  const groupedMenuItems = categories.map((category) => ({
    category,
    items: menuItems.filter((item) => item.category === category),
  }));

  const formatImageUrl = (url) => encodeURI(url);

  return (
    <div className="menu">
      <h1>Menu</h1>
      {groupedMenuItems.map(({ category, items }) => (
        <div key={category} className="menu-category-section">
          <h2 className="menu-category-title">{category}</h2>
          <div className="menu-items">
            {items.map((item) => {
              const selectedVariant = selectedVariants[item._id] || item.variantOptions?.[0] || '';
              const variantLabel = item.name?.toLowerCase().includes('delmonte')
                ? 'Delmonte variety'
                : item.name?.toLowerCase().includes('soda')
                  ? 'Soda variety'
                  : `${item.name} variety`;
              return (
                <div key={item._id} className="menu-item">
                  <img src={formatImageUrl(item.image)} alt={item.name} />
                  <h3>{item.name}</h3>
                  <p>{item.description}</p>
                  <p>Ksh {item.price}</p>
                  {item.variantOptions?.length > 0 && (
                    <div className="menu-item-variant">
                      <label htmlFor={`variant-${item._id}`}>{variantLabel}</label>
                      <select
                        id={`variant-${item._id}`}
                        value={selectedVariant}
                        onChange={(event) => handleVariantChange(item._id, event.target.value)}
                      >
                        {item.variantOptions.map((variant) => (
                          <option key={variant} value={variant}>
                            {variant}
                          </option>
                        ))}
                      </select>
                    </div>
                  )}
                  <button onClick={() => handleAddToCart(item)}>Add to Cart</button>
                </div>
              );
            })}
          </div>
        </div>
      ))}
    </div>
  );
};

export default Menu;